import React, { useState } from 'react';
import api from '../../config/api';
import endpoints from '../../config/endpoints';
import { STORAGE_KEYS } from '../../context/AuthContext';
import { useAnalytics } from '../../hooks/useAnalytics';

export const WishlistButton = ({ featureId }) => {
    const [showEmailForm, setShowEmailForm] = useState(false);
    const [email, setEmail] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);
    const { trackEvent, events } = useAnalytics();

    const getUserEmail = () => {
        const storedUser = localStorage.getItem(STORAGE_KEYS.USER);
        if (!storedUser) return null;
        try {
            const user = JSON.parse(storedUser);
            return user.email;
        } catch (error) {
            console.error('Error parsing user data:', error);
            return null;
        }
    };

    const handleSubmit = async (e) => {
        e?.preventDefault();
        setIsLoading(true);
        setError('');

        try {
            const userEmail = getUserEmail();
            const requestData = userEmail ? {} : { email };
            
            await api.post(endpoints.feedback.wishlist(featureId), requestData);
            trackEvent(events.FEATURE.WISHLIST_JOIN, 'feature', {
                feature_id: featureId,
                is_logged_in: !!userEmail,
                success: true
            });
            setSuccess(true);
            setShowEmailForm(false);
        } catch (error) {
            trackEvent(events.SYSTEM.ERROR, 'system', {
                action: 'wishlist_join',
                feature_id: featureId,
                error: error.message,
                is_logged_in: !!getUserEmail()
            });
            setError('Failed to add to wishlist. Please try again.');
            console.error('Wishlist error:', error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleWishlistClick = () => {
        const userEmail = getUserEmail();
        trackEvent(events.FEATURE.WISHLIST_JOIN, 'feature', {
            action: 'initiate',
            feature_id: featureId,
            is_logged_in: !!userEmail
        });
        if (userEmail) {
            handleSubmit();
        } else {
            setShowEmailForm(true);
        }
    };

    if (success) {
        return (
            <div className="text-green-600 font-medium">
                Added to wishlist successfully!
            </div>
        );
    }

    return (
        <div className="space-y-4">
            {showEmailForm ? (
                <form onSubmit={handleSubmit} className="space-y-3">
                    <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="Enter your email"
                        className="w-full p-2 border border-gray-300 rounded-lg"
                        required
                    />
                    <div className="flex space-x-2">
                        <button
                            type="submit"
                            disabled={isLoading}
                            className="bg-indigo-600 text-white px-4 py-2 rounded-lg hover:bg-indigo-700 transition-colors disabled:opacity-50"
                        >
                            {isLoading ? 'Adding...' : 'Add to Wishlist'}
                        </button>
                        <button
                            type="button"
                            onClick={() => setShowEmailForm(false)}
                            className="bg-gray-200 text-gray-800 px-4 py-2 rounded-lg hover:bg-gray-300 transition-colors"
                        >
                            Cancel
                        </button>
                    </div>
                </form>
            ) : (
                <button
                    onClick={handleWishlistClick}
                    disabled={isLoading}
                    className="bg-indigo-600 text-white px-6 py-2 rounded-lg hover:bg-indigo-700 transition-colors disabled:opacity-50"
                >
                    {isLoading ? 'Adding...' : 'Add to Wishlist'}
                </button>
            )}
            {error && <div className="text-red-600">{error}</div>}
        </div>
    );
}; 